import { OKTA_USER_INFO, SET_MARKET_LANGUAGES, SET_MARKET_LANGUAGES_LOADER } from "../actions/commonDataActions";

  
  const initialState = {
    oktaUserInfo: null,
    marketLanguages: [],
    marketLanguagesLoader: false,
  };
  
  export const commonDataReducer = (state = initialState, action) => {
    switch (action.type) {
      case OKTA_USER_INFO:
        return {
          ...state,
          oktaUserInfo: action?.payload || [],
        };

      case SET_MARKET_LANGUAGES:
        return {
          ...state,
          marketLanguages: action?.payload || [],
        };
  
        case SET_MARKET_LANGUAGES_LOADER:
          return {
            ...state,
            marketLanguagesLoader: action?.payload || state.marketLanguagesLoader,
          };
    

      default:
        return state;
    }
  };
  